var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftArr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 66,
    viewBox: "0 0 97 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.1469 32.8438H24.3809",
    stroke: "black",
    strokeMiterlimit: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 32.8445C1 50.4305 15.257 64.6875 32.843 64.6875C50.43 64.6875 64.687 50.4305 64.687 32.8445C64.687 15.2575 50.43 1.0005 32.843 1.0005C15.257 1.0005 1 15.2575 1 32.8445Z",
    stroke: "black",
    strokeMiterlimit: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3218 28.7546L28.0038 29.4866L24.3918 32.8436L28.0038 36.2006L27.3218 36.9336L22.9238 32.8436L27.3218 28.7546Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArr);
export default __webpack_public_path__ + "static/media/leftArr.014304bd4079628b70c6d17cc737ca0d.svg";
export { ForwardRef as ReactComponent };